import React, { useEffect, useState, useRef } from "react";
import "./stylessh.css";
import { conac } from "../../../json/conac";


const Conac = () => {
 
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Consejo Nacional de Armonización Contable</h1>
          </div>
        </div>
      </div>
    
       <div className="steps-row">
        {conac.map((item, index) => (
          <div key={index} className="col-12 seccion">
                <h1 className="mt-5 titulo-seccion">{item.id_trimestre}</h1>
                <div className="containerConac">
                <img width="400"  src={item.img_url}/>                    
                </div>
                <div className="bloque">
                {item.titulos_array.map((title, i) => (      
                    <div>  
                      <h5 className="mt-3">{title.titulo_item_nombre}</h5>
                      <p className="mt-1">{title.descripcion_titulo}</p>
                        {title.titulo_item_nombre !== "" ? (
                      
                          <div>
                            {title.archivos_array.map((archivo, j) => (                   
                              <div>
                              {" "}
                              <a className="archivo-pdf"
                                target="{_blank}"
                                key={i}
                                href={archivo.file_item_url}
                              >
                                {archivo.file_item_nombre}
                              </a>{" "}
                            </div>

                            ))}
                          </div>
                      ) : (
                        <div>
                        {title.archivos_array.map((archivo, j) => (                   
                          <div>
                          {archivo.file_item_nombre}{" "}
                          <a className="btn-link-c archivo-pdf"
                            target="{_blank}"
                            key={i}
                            href={archivo.archivos.pdf}
                          ></a>{"  "}
                          <a className="btn-link-c archivo-xls"
                            target="{_blank}"
                            key={i}
                            href={archivo.archivos.xls}
                          >                            
                          </a>
                        </div>
                        ))}
                      </div>
                      ) } 
                    </div>
                ))}
                        
              </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Conac;
